import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 22,
  medium: 16,
  small: 12,
  xSmall: 9
};
const XIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.5222 13.9238L22.4785 7H21.0671L15.8952 13.0118L11.7644 7H7L13.2466 16.0909L7 23.3516H8.41155L13.8732 17.0029L18.2356 23.3516H23L16.5218 13.9238H16.5222ZM14.5889 16.171L13.956 15.2658L8.92015 8.06259H11.0882L15.1522 13.8758L15.7851 14.7811L21.0677 22.3373H18.8997L14.5889 16.1714V16.171Z",
        fill: "currentColor"
      }
    )
  );
};
XIcon.iconName = "XIcon";

export { XIcon };
